<template>
  <SmPopover class="popover">
    <template v-slot:trigger="{ togglePopover }">
      <slot :event="togglePopover"></slot>
    </template>

    <template v-slot:content>
      <div class="popover__content">
        <div class="popover__content--link" @click="chooseWay('yandex')">
          <LocateIcon />
          <span>Яндекс карты</span>
        </div>
        <div class="popover__content--devider"></div>
        <div class="popover__content--link" @click="chooseWay('google')">
          <LocateIcon />
          <span>Google maps</span>
        </div>
      </div>
    </template>
  </SmPopover>
</template>
<script>
import { useDisplay } from '@/hooks'
import { SmPopover } from '@/shared'

import LocateIcon from '@/assets/icons/locate'

export default {
  name: 'NavigateEventButton',
  props: ['clinicInfo'],
  components: {
    SmPopover,
    LocateIcon
  },
  setup(props) {
    const { clinicInfo } = props

    const display = useDisplay()

    function chooseWay(mapsChange) {
      const destinationLat = clinicInfo.latitude
      const destinationLng = clinicInfo.longitude

      switch (mapsChange) {
        case 'google': {
          const url = `https://www.google.com/maps/dir/?api=1&destination=${destinationLat},${destinationLng}&travelmode=driving`
          window.open(url, '_blank')
          break
        }
        case 'yandex': {
          const url = `https://yandex.ru/maps/?rtext=~${destinationLat},${destinationLng}&rtt=auto`
          window.open(url, '_blank')
          break
        }
      }
    }

    return {
      display,
      chooseWay
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
